import { Component, Input } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { LanguageSelectorResponse } from "../../../dtos/language-selector.response.dto";
import { DialogBase } from "../dialog-base";

@Component({
    standalone: false,
    selector: 'language-selector-dialog',
    templateUrl: './language-selector-dialog.component.html',
    styleUrls: ['./language-selector-dialog.component.scss']
})

export class LanguageSelectorDialogComponent extends DialogBase<LanguageSelectorDialogComponent, LanguageSelectorResponse[]> {
    selectLanguage(language: string): void {
        this.dialog.close(language);
    }
}
